/* BeautyEssence mega menu: open on hover (desktop with a mouse). Click and keyboard behaviour stay as Dawn's.
   - Opens after a short hover intent (110 ms) so passing the mouse across the header doesn't flash panels.
   - Closes 220 ms after the pointer leaves both the menu word and its panel (time to move into the panel).
   - Only one panel open at a time.
   - With a mouse, clicking the menu word while its panel is open goes to the collection ("Shop all" link)
     instead of closing the panel. Keyboard (Enter/Space) still toggles the panel as before. */
(function () {
  if (window.__beMegaHover) return;
  window.__beMegaHover = true;
  var mq = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)') : null;
  var OPEN_DELAY = 110;
  var CLOSE_DELAY = 220;

  function menus() { return Array.prototype.slice.call(document.querySelectorAll('details.be-mega-menu')); }
  function setOpen(d, open) {
    if (open === d.hasAttribute('open')) return;
    if (open) d.setAttribute('open', ''); else d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function bind(d) {
    if (d.__beHover) return;
    d.__beHover = true;
    var openT = 0, closeT = 0;
    d.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !mq || !mq.matches) return;
      window.clearTimeout(closeT);
      openT = window.setTimeout(function () {
        menus().forEach(function (o) { if (o !== d) setOpen(o, false); });
        setOpen(d, true);
        d.__beHoverOpened = Date.now();
      }, OPEN_DELAY);
    });
    d.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse' || !mq || !mq.matches) return;
      window.clearTimeout(openT);
      closeT = window.setTimeout(function () {
        if (d.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return; /* keyboard user inside */
        setOpen(d, false);
      }, CLOSE_DELAY);
    });
    var summary = d.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (!mq || !mq.matches || e.detail === 0) return; /* keyboard activation: keep Dawn's toggle */
        if (d.hasAttribute('open')) {
          var all = d.querySelector('.be-mega__all');
          if (all && all.href) { e.preventDefault(); window.location.href = all.href; }
        }
      });
    }
  }

  function init() { menus().forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
